import { ChangeDetectionStrategy, Component, Input, input, output } from '@angular/core';
import { FormOption } from '@core/navigation/store/state';
import { BreadcrumbItem } from '../long-breadcrumb/breadcrumb-item/breadcrumb-item.component';
import { MatButton } from '@angular/material/button';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-short-breadcrumb',
    templateUrl: './short-breadcrumb.component.html',
    styleUrls: ['./short-breadcrumb.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        MatButton,
        MatMenuTrigger,
        MatIcon,
        MatMenu,
        MatMenuItem,
    ]
})
export class ShortBreadcrumbComponent {
  readonly breadcrumbs = input<BreadcrumbItem[]>([]);
  @Input() set forms(forms: FormOption[]) {
    this._forms = forms?.length ? forms : [];
    this.selectedForm = this._forms.length ? this._forms[0] : null;
  }
  readonly breadcrumbClicked = output<BreadcrumbItem>();
  readonly formSelected = output<string>();

  get forms(): FormOption[] {
    return this._forms;
  }
  selectedForm: FormOption = null;
  isMenuOpened: boolean = false;

  private _forms: FormOption[] = [];

  onOptionSelected(form: FormOption) {
    if (form && form.id !== this.selectedForm?.id) {
      this.selectedForm = form;
      this.formSelected.emit(form.id);
    }
  }
}
